export default __webpack_public_path__ + "media/images/imageedit_5_6371326025-c159199394df021dd31523869714e12a.png";